import { render } from "./ApprovalIdleDealAssignTable.vue?vue&type=template&id=a832313c&scoped=true"
import script from "./ApprovalIdleDealAssignTable.vue?vue&type=script&lang=js"
export * from "./ApprovalIdleDealAssignTable.vue?vue&type=script&lang=js"

import "./ApprovalIdleDealAssignTable.vue?vue&type=style&index=0&id=a832313c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a832313c"]])

export default __exports__